import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  fullWidth = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-bold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-900 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#00d4aa] text-black hover:bg-[#00bfa0] hover:shadow-[0_0_20px_rgba(0,212,170,0.4)] border border-transparent',
    secondary: 'bg-[#f59e0b] text-black hover:bg-[#e0920a] hover:shadow-[0_0_20px_rgba(245,158,11,0.4)] border border-transparent',
    outline: 'bg-transparent border-2 border-[#00d4aa] text-[#00d4aa] hover:bg-[#00d4aa]/10',
    ghost: 'bg-transparent text-gray-300 hover:text-white hover:bg-white/5'
  };
  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-5 py-2.5 text-base',
    lg: 'px-6 py-3 text-lg',
    xl: 'px-8 py-4 text-xl'
  };
  return <button className={`
        ${baseStyles}
        ${variants[variant]}
        ${sizes[size]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} disabled={disabled || isLoading} {...props} data-id="element-212">
      {isLoading && <Loader2 className="mr-2 h-5 w-5 animate-spin" data-id="element-213" />}
      {children}
    </button>;
}